import { uiComponents, uiStates } from '@/tools/viewState';

import { actionTypes, mutationTypes, errorTypes } from '@/types';
import { generateUUID } from '@/tools/helpers';
import { getValueLanguageConent } from '@/tools/languageValue';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';

import { SEARCH_SCOPES, PACKAGE_SYNCER_MODES, syncActionStates } from '@/tools/consts';
import logger from '@/tools/logger';

/**
 * This action open the ui--search with scope Exhibitions. Pass an exhibitionID to
 * show all articles of belonging exhibition
 * @param {*} store
 * @param { id } exhibitionID
 * @params { { sortBy } } options sorty which tag (name, title, description) default title
 */
export default function ({ rootState, commit, dispatch }, { options = {} }) {
	const exhibitions = rootState.dataSourceCFG.exhibitions;
	const { sortBy } = Object.assign({ sortBy: 'title' }, options);
	const isOfflineSync =
		rootState.packageSyncer.isSyncerApp && rootState.packageSyncer.mode === PACKAGE_SYNCER_MODES.exhibition;
	const data = exhibitions
		.filter((exhibition) => {
			exhibition.languageContent.filter((lc) => lc.languageISO === rootState.persistent.language)[0];
			return !exhibition.isVirtual && exhibition.isInExhibitionList;
		})
		.reduce((acc, exhibition) => {
			// If the app is a downloader app
			let showDownloadUI = isOfflineSync
				? !!rootState.packageSyncer.subParts[exhibition.exhibitionID]
				: false;
			let languageContent = exhibition.languageContent.find(
				(lc) => lc.languageISO === rootState.persistent.language
			);
			const languageContentIsMissing = !languageContent;
			const _showDownloadUI = showDownloadUI;
			// If the selected laguage can not be found,
			if (languageContentIsMissing) {
				// Fall back to the default laguage if there is a function for dealing with clicks on missing content
				if (window.exhibitionListLaguageMissing) {
					// Do not show the download UI if the laguage is missing to only show the UI that the plugin provides.
					showDownloadUI = false;
					languageContent = exhibition.languageContent.filter(
						(lc) => lc.languageISO === rootState.dataSourceCFG.global.defaultLanguage
					)[0];
				}
				// If there is no fallback function skip this entrly
				else {
					logger.warn(
						`The exhibition "${exhibition.name}" doese not have the language "${rootState.persistent.language}" and there is no fallback function (window.exhibitionListLaguageMissing) implemented in a plugin therefore it is removed from the list.`
					);
					return acc;
				}
			}
			// If e.g. the default language is also missing we might
			// not have a language here, so skipp the entry
			if (!languageContent) {
				logger.warn(
					`The exhibition "${exhibition.name}" doese not have the language "${rootState.persistent.language}" and fallback language "${rootState.dataSourceCFG.global.defaultLanguage}".`
				);
				return acc;
			}
			languageContent.cover = exhibition.coverID
				? setUrlToDataSource(
						`../media-${getValueLanguageConent(exhibition.coverID.languageContent, 'source')}/512`,
						rootState.dataSourceURL
				  )
				: undefined;
			acc.push({
				id: exhibition.exhibitionID,
				key: generateUUID(),
				name: exhibition.name,
				class: 'data--' + exhibition.exhibitionID,
				active: `${Object.prototype.hasOwnProperty.call(
					rootState.visitedExhibtionIDs,
					exhibition.exhibitionID
				)}`,
				url: '',
				role: 'link',
				click: () => {
					if (languageContentIsMissing) {
						if (window.exhibitionListLaguageMissing) {
							window.exhibitionListLaguageMissing({
								exhibitionID: exhibition.exhibitionID,
								showDownloadUI: _showDownloadUI,
							});
							return;
						} else {
							alert('please go back and choose a different language');
							return;
						}
					}
					if (
						showDownloadUI &&
						rootState.packageSyncer.subPartStates[exhibition.exhibitionID] !== syncActionStates.loaded
					) {
						dispatch(actionTypes.sendErrorMessage, {
							error: new Error(errorTypes.packageSyncerExhibitionNotDownloaded),
						});
						return;
					}
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiSearchExhibitions,
						uiState: uiStates.hidden,
					});
					dispatch(actionTypes.setExhibition, { exhibitionID: exhibition.exhibitionID });
				},
				showDownloadUI,
				...languageContent,
			});
			return acc;
		}, []) // eslint-disable-next-line
		.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : a[sortBy] < b[sortBy] ? -1 : 0));
	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.exhibitions,
		data,
		searchOptions: {
			keys: ['title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		options,
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchExhibitions,
		uiState: uiStates.maximised,
	});
}
